import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';

import MaterialDivider from './MaterialDivider';

const BufferForm = ({ index, data }) => {
  const { 
    handleDelete, handleInputChange, initialValues, formErrors
  } = useContext(MaterialsCaptureContext);

  return(
    <Box mt={4}>
      <MaterialDivider 
        index={index} 
        title={'Buffer'} 
        showDeleteIcon={true} 
        handleDelete={handleDelete} 
        deleteIndex={data?.index} 
      />
      
      <Grid container spacing={1} mt={1}>
        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Unique ID"
            name={`unique_id-${data?.index}`}
            value={data?.unique_id}
            onChange={e => 
              handleInputChange(e, data?.index, 'unique_id', e.target.value)
            }
            helperText={formErrors[`unique_id-${data?.index}`]}
            error={`unique_id-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            value={data?.operator}
            onChange={(e, newValue) => 
              handleInputChange(e, data?.index, 'operator', newValue)
            }
            onInputChange={(e, newValue) =>
              handleInputChange(e, data?.index, 'operator', newValue)
            }
            options={initialValues?.operator}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Operator" 
                placeholder="Type to search Operator..." 
                error={`operator-${data?.index}` in formErrors}
                helperText={formErrors[`operator-${data?.index}`]}
              />
            )}
            freeSolo
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <FormControl fullWidth>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label='Date Prepared'
                name={`date_prepared-${data?.index}`}
                value={data?.date_prepared} 
                onChange={e => 
                  handleInputChange(e, data?.index, 'date_prepared', e)
                } 
                maxDate={initialValues?.today}
                renderInput={(params) => 
                  <TextField 
                    {...params} 
                    error={Boolean(formErrors[`date_prepared-${data?.index}`])}
                    helperText={formErrors[`date_prepared-${data?.index}`]}
                  />
                }
              />
            </LocalizationProvider>
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            value={data?.buffer_acronym}
            onChange={(e, newValue) => 
              handleInputChange(e, data?.index, 'buffer_acronym', newValue)
            }
            options={initialValues?.buffer_acronym_list}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Buffer Acronym" 
                placeholder="Type to search Buffer Acronym..." 
                error={`buffer_acronym-${data?.index}` in formErrors}
                helperText={formErrors[`buffer_acronym-${data?.index}`]}
              />
            )}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Target pH"
            name={`target_pH-${data?.index}`}
            value={data?.target_pH}
            onChange={e => 
              handleInputChange(e, data?.index, 'target_pH', e.target.value)
            }
            helperText={formErrors[`target_pH-${data?.index}`]}
            error={`target_pH-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Measured pH"
            name={`measured_pH-${data?.index}`}
            value={data?.measured_pH}
            onChange={e => 
              handleInputChange(e, data?.index, 'measured_pH', e.target.value)
            }
            helperText={formErrors[`measured_pH-${data?.index}`]}
            error={`measured_pH-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer concentration (mmol)"
            name={`buffer_concentration-${data?.index}`}
            value={data?.buffer_concentration}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'buffer_concentration', e.target.value
              )
            }
            helperText={formErrors[`buffer_concentration-${data?.index}`]}
            error={`buffer_concentration-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 1"
            name={`buffer_component_1-${data?.index}`}
            value={data?.buffer_component_1}
            onChange={e => 
              handleInputChange(e, data?.index, 'buffer_component_1', e.target.value)
            }
            helperText={formErrors[`buffer_component_1-${data?.index}`]}
            error={`buffer_component_1-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 1 (concentration mM)"
            name={`buffer_component_1_concentration-${data?.index}`}
            value={data?.buffer_component_1_concentration}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'buffer_component_1_concentration', e.target.value
              )
            }
            helperText={formErrors[`buffer_component_1_concentration-${data?.index}`]}
            error={`buffer_component_1_concentration-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>
        
        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 2"
            name={`buffer_component_2-${data?.index}`}
            value={data?.buffer_component_2}
            onChange={e => 
              handleInputChange(e, data?.index, 'buffer_component_2', e.target.value)
            }
            helperText={formErrors[`buffer_component_2-${data?.index}`]}
            error={`buffer_component_2-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 2 (concentration mM)"
            name={`buffer_component_2_concentration-${data?.index}`}
            value={data?.buffer_component_2_concentration}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'buffer_component_2_concentration', e.target.value
              )
            }
            helperText={formErrors[`buffer_component_2_concentration-${data?.index}`]}
            error={`buffer_component_2_concentration-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 3"
            name={`buffer_component_3-${data?.index}`}
            value={data?.buffer_component_3}
            onChange={e => 
              handleInputChange(e, data?.index, 'buffer_component_3', e.target.value)
            }
            helperText={formErrors[`buffer_component_3-${data?.index}`]}
            error={`buffer_component_3-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>
        
        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 3 (concentration mM)"
            name={`buffer_component_3_concentration-${data?.index}`}
            value={data?.buffer_component_3_concentration}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'buffer_component_3_concentration', e.target.value
              )
            }
            helperText={formErrors[`buffer_component_3_concentration-${data?.index}`]}
            error={`buffer_component_3_concentration-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 4"
            name={`buffer_component_4-${data?.index}`}
            value={data?.buffer_component_4}
            onChange={e => 
              handleInputChange(e, data?.index, 'buffer_component_4', e.target.value)
            }
            helperText={formErrors[`buffer_component_4-${data?.index}`]}
            error={`buffer_component_4-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 4 (concentration mM)"
            name={`buffer_component_4_concentration-${data?.index}`}
            value={data?.buffer_component_4_concentration}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'buffer_component_4_concentration', e.target.value
              )
            }
            helperText={formErrors[`buffer_component_4_concentration-${data?.index}`]}
            error={`buffer_component_4_concentration-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 5"
            name={`buffer_component_5-${data?.index}`}
            value={data?.buffer_component_5}
            onChange={e => 
              handleInputChange(e, data?.index, 'buffer_component_5', e.target.value)
            }
            helperText={formErrors[`buffer_component_5-${data?.index}`]}
            error={`buffer_component_5-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 5 (concentration mM)"
            name={`buffer_component_5_concentration-${data?.index}`}
            value={data?.buffer_component_5_concentration}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'buffer_component_5_concentration', e.target.value
              )
            }
            helperText={formErrors[`buffer_component_5_concentration-${data?.index}`]}
            error={`buffer_component_5_concentration-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 6"
            name={`buffer_component_6-${data?.index}`}
            value={data?.buffer_component_6}
            onChange={e => 
              handleInputChange(e, data?.index, 'buffer_component_6', e.target.value)
            }
            helperText={formErrors[`buffer_component_6-${data?.index}`]}
            error={`buffer_component_6-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer component 6 (concentration mM)"
            name={`buffer_component_6_concentration-${data?.index}`}
            value={data?.buffer_component_6_concentration}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'buffer_component_6_concentration', e.target.value
              )
            }
            helperText={formErrors[`buffer_component_6_concentration-${data?.index}`]}
            error={`buffer_component_6_concentration-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
};

BufferForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default BufferForm;